<template lang="pug">
	.creative--templates--new-creative
		.flex-col.space-large
			.flex-col(v-if="!hideCreativeName")
				.font-small.upper.grey {{$tCaption('Creative name')}}
				DxTextBox(:value.sync="newCreativeName", stylingMode="filled")
			template(v-for="templateField in templateFields")
				FullStructureParameterSelector(ref="baseParam", v-bind="getBaseParamBindOptions(templateField)", @change="(paramValues, paramCaptions) => onTemplateFieldParametersChange(templateField, paramValues, paramCaptions)")
			.flex-col.space-large(v-if="isNewsML")
				.flex-col.space
					.font-big.upper.grey {{$tCaption('News ML')}}
					.flex-col(v-if="!newsMLFtpMode")
						.font-tiny.upper.grey {{$tCaption('Url/File')}}
						.flex-row.space.align-center
							DxTextBox.flex-1(v-if="!newsML.file", :value.sync="newsML.url", stylingMode="filled", valueChangeEvent="input")
							.flex-1(v-if="newsML.file") {{newsML.file.name}}
							DxButton(v-if="newsML.file", icon="close", @click="newsML.file = null", :hint="$tCaption('Remove newsML zip-file')")
							DxButton(icon="upload", @click="$refs.newsMLUploader.showPopup()", :hint="$tCaption('Upload newsML zip-file')")
					.flex-col
						.font-tiny.upper.grey {{$tCaption('Top headline:')}}
						DxNumberBox.flex-1(:value.sync="newsML.topHeadline", stylingMode="filled", valueChangeEvent="input", :show-spin-buttons="true")
					.flex-col
						.font-tiny.upper.grey {{$tCaption('Top content:')}}
						DxNumberBox.flex-1(:value.sync="newsML.topContent", stylingMode="filled", valueChangeEvent="input", :show-spin-buttons="true")
				template(v-if="newsMLFtpMode")
					.flex-col.space
						.font-big.upper.grey {{$tCaption('FTP settings')}}
						.flex-col.space
							.flex-col
								.font-tiny.upper.grey {{$tCaption('URL')}}
								DxTextBox(:value.sync="newsML.ftpImportOptions.ftpUrl", stylingMode="filled")
							.flex-col
								.font-tiny.upper.grey {{$tCaption('User')}}
								DxTextBox(:value.sync="newsML.ftpImportOptions.ftpUser", stylingMode="filled")
							.flex-col
								.font-tiny.upper.grey {{$tCaption('Password')}}
								DxTextBox(:value.sync="newsML.ftpImportOptions.ftpPassword", mode="password", stylingMode="filled", 
									:useMaskedValue="true", :input-attr="{ autocomplete: 'new-password', id: 'new-password' }")
							.flex-col
								.font-tiny.upper.grey {{$tCaption('ftpDirectory')}}
								DxTextBox(:value.sync="newsML.ftpImportOptions.ftpDirectory", stylingMode="filled")
							.flex-col
								.font-tiny.upper.grey {{$tCaption('postImportAction')}}
								DxSelectBox(:value.sync="newsML.ftpImportOptions.postImportAction", :dataSource="postImportActions", valueExpr="id", displayExpr="name", stylingMode="filled")
		FileUploader(ref="newsMLUploader", :isUIHidden="true", @upload="onNewsMLUploaded", :accept="['.zip']")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import FileUploader from 'app-core/FileUploader.vue';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxNumberBox from 'devextreme-vue/number-box';
	import Loader from 'app-core/Loader.vue';
	import DxValidator, { DxRequiredRule } from 'devextreme-vue/validator';
	import serviceHelper from 'view/webServiceCaller/service-helper';
	import BaseParameterSelector from 'view/webServiceCaller/BaseParameterSelector.vue';
	import FullStructureParameterSelector from 'view/webServiceCaller/FullStructureParameterSelector.vue';
	import DxSelectBox from 'devextreme-vue/select-box';
	import { 
		PERSISTENT_SCHEDULE_POST_IMPORT_ACTION
	} from 'app-core/constants';

	export default {
		translationCategory: 'creative.CreativeTemplates',
		name: 'creative--templates--new-creative--templates',
		components: {
			DxTextBox, Loader, DxValidator, DxRequiredRule, BaseParameterSelector, FullStructureParameterSelector, DxButton, 
			FileUploader, DxNumberBox, DxSelectBox
		},
		props: ['templateFields', 'name', 'hideCreativeName', 'template', 'newsMLFtpMode', 'newsMLData'],
		computed: {
			isNewsML() {
				return this.template?.IsNewsMLTemplate;
			}
		},
		data() {
			let postImportActions = PERSISTENT_SCHEDULE_POST_IMPORT_ACTION.toLocale('name', this);
			return {
				newCreativeName: this.name || this.$tCaption('New creative'),
				newsML: _.assign({
					file: null,
					url: null,
					topHeadline: this.template?.JsonConfig?.newsMLTopHeadline,
					topContent: this.template?.JsonConfig?.newsMLTopContent,
					ftpImportOptions: {
						ftpUrl: '',
						ftpUser: '',
						ftpPassword: '',
						ftpDirectory: '',
						postImportAction: 0
					}
				}, _.cloneDeep(this.newsMLData || {})),
				postImportActions,
				emittingNewsML: false
			}
		},
		watch: {
			newCreativeName(v) {
				this.$emit('update:name', v);
			},
			newsML: {
				handler() {
					this.emitNewsML();
				},
				deep: true
			},
			newsMLData() {
				if (this.emittingNewsML) return;
				_.assign(this.newsML, this.newsMLData);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.creativeTemplatesNewCreative = this;
		},
		methods: {
			emitNewsML() {
				this.emittingNewsML = true;
				this.$emit('newsML', this.newsML);
				this.$nextTick(() => this.emittingNewsML = false);
			},
			onNewsMLUploaded(e) {
				this.newsML.file = e[0];
			},
			onTemplateFieldParametersChange(templateField, paramValues, paramCaptions) {
				if (__DEBUG__)
					console.debug('onTemplateFieldParametersChange', { templateField, paramValues, paramCaptions });

				if (!templateField.services) {
					templateField.services = [];
				}

				templateField.services = Object.keys(paramValues).map(paramName => {
					const res = {
						Name: paramName,
						Value: paramValues[paramName]
					}
					if (paramCaptions && paramCaptions[paramName]) {
						res.Caption = paramCaptions[paramName];
					}
					return res;
				});

				this.$set(templateField, 'default', paramCaptions && paramCaptions[templateField.id] || paramValues[templateField.id]);
			},
			getBaseParamBindOptions(templateField) {
				let bindOptions = {
					paramResolver: () => serviceHelper.getParamFromTemplateField(templateField, this),
					parameter: null,
					...this.getParamValuesFromTemplateField(templateField)
				}

				if (__DEBUG__) 
					console.debug(`getBaseParamBindOptions ${templateField?.id}`, bindOptions, JSON.stringify(bindOptions, void 0, '   '));

				return bindOptions;
			},
			getParamValuesFromTemplateField(templateField) {
				return (templateField.services || []).reduce((res, f) => {
					res.paramValues[f.Name] = f.Value;
					if (f.Caption)
						res.paramCaptions[f.Name] = f.Caption;
					return res;
				}, { paramValues: {}, paramCaptions: {} });
			},
		}
	};
</script>

<style lang="scss">
	@import "main/themes/generated/variables.base.scss";

	.creative--templates--new-creative {
	}
</style>
